import { LoaderContainer, Loader } from "./styles";
import { FC } from "react";

const ScrollLoader: FC = () => {
  return (
    <LoaderContainer className="loader">
      <Loader src="/assets/scroll_loader.svg" alt="Scroll Loader" />
    </LoaderContainer>
  );
};

export default ScrollLoader;
